// extracted by mini-css-extract-plugin
export default {"containerContent":"StackedBarChart_containerContent__NOt48","zoomed":"StackedBarChart_zoomed__5AbXz"};